<template>
  <div class="imgDiv">
    <el-image style="margin: 3px 10px 3px 3px"
              :style ="{'width':width,'height':height}"
              v-for="(item,index) in imageList" :key="item.id" :src="item[urlField]" :preview-src-list="getImgList(index)"/>
  </div>
</template>

<script>
export default {
  name: "ImageView",
  props: {
    width: {type:String, default:'144px'},
    height: {type:String, default:'144px'},
    urlField: {type:String, default:'url'},
    imageList: {type:Array, default: function () {
        return []
      }},
  },

  data() {
    return {

    };
  },
  created () {
  },
  methods: {


    getImgList(index) {
      let arr = []
      let i = 0;
      for(i;i < this.imageList.length;i++){
        arr.push(this.imageList[i+index][this.urlField])
        if(i+index >= this.imageList.length-1){
          index = 0-(i+1);
        }
      }
      return arr;
    },
  }
}
</script>

<style scoped>

.imgDiv{
  border: solid 1px #e5e5e5;
  padding: 5px;
  height:150px;
}

</style>



